import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  ActivityIndicator,
  Alert,
  Image,
  Dimensions,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useAuthData } from "../hooks/useAuthData";
import { useMutation } from "convex/react";
import { api } from "../convex/_generated/api";
import { fontFamily } from "../constants/fonts";
import { colors } from "../constants/theme";

const { width: WIN_W } = Dimensions.get("window");
const LOGO_SIZE = Math.min(WIN_W * 0.4, 220);

function ReferralScreen({ onReferralSubmitted, onSkip }) {
  const [referralCode, setReferralCode] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const { authData } = useAuthData();
  const membershipReferral = useMutation(api.memberships.membershipReferral);

  const handleReferralCodeChange = (code) => {
    setReferralCode(code);
  };

  const handleContinuePress = async () => {
    setShowSpinner(true);
    setDisableButton(true);

    if (referralCode.trim().length === 0) {
      Alert.alert(
        "Referral Code",
        "Please enter a valid referral code or skip if you don’t have one.",
      );
      setShowSpinner(false);
      setDisableButton(false);
      return;
    }

    try {
      const privyDid = authData.privyDid;
      const result = await membershipReferral({
        referralCode: referralCode,
        redeemerPrivyDid: privyDid,
      });
      if (result.success) {
        Alert.alert(
          "Referral Success",
          "You have successfully redeemed the referral.",
        );
        onReferralSubmitted(referralCode);
      } else {
        Alert.alert(
          "Referral Failed",
          result.failureMessage ||
            "An error occurred while processing the referral.",
        );
      }
    } catch (error) {
      console.error("Error submitting referral code:", error);
      Alert.alert("Error", "An error occurred, please try again later.");
    } finally {
      setShowSpinner(false);
      setDisableButton(false);
    }
  };

  return (
    <View style={{ flex: 1, paddingHorizontal: 24, alignItems: "center", justifyContent: "flex-start", paddingBottom: 80 }}>
      <Image
        source={require("../assets/DisgoLogoBlack.png")}
        style={{ width: LOGO_SIZE, height: LOGO_SIZE, alignSelf: "center", marginTop: 16, resizeMode: "contain" }}
      />

      <Text style={{ color: colors.black, fontFamily: fontFamily.abhayaBold, fontSize: 24 }}>
        Referred to Disgo?
      </Text>
      <Text style={{ color: colors.black, fontFamily: fontFamily.abhaya, fontSize: 16, textAlign: "center", marginTop: 16, paddingHorizontal: 16 }}>
        Had to download it first? You can now copy the perk link your friend
        sent to claim it!
      </Text>

      <Text style={{ color: colors.black, fontFamily: fontFamily.abhayaBold, fontSize: 20, textAlign: "center", marginTop: 8, paddingHorizontal: 16 }}>
        Copy the code at the end of the link and paste below:
      </Text>

      <View style={{ flexDirection: "row", alignItems: "center", marginTop: 24, width: "100%", justifyContent: "center" }}>
        <View style={{ flexDirection: "row", alignItems: "center", backgroundColor: colors.white, borderRadius: 9999, borderWidth: 2, borderStyle: "dashed", borderColor: colors.black, paddingHorizontal: 16, paddingVertical: 8, width: "100%" }}>
          <TextInput
            onChangeText={handleReferralCodeChange}
            value={referralCode}
            placeholder="[X X X]"
            placeholderTextColor="#999"
            style={{ flex: 1, fontSize: 18, fontFamily: fontFamily.abhaya, paddingVertical: 8, color: '#000000' }}
          />
          <TouchableOpacity
            disabled={disableButton}
            onPress={handleContinuePress}
            style={{ marginLeft: 8 }}
          >
            <Ionicons name="arrow-forward-circle" size={32} color="black" />
          </TouchableOpacity>
        </View>
      </View>

      <Text style={{ color: colors.black, fontFamily: fontFamily.abhaya, fontSize: 14, textAlign: "center", marginTop: 16 }}>
        ex: https://thedisgo.com/claim/k57o135gdnye5x3ly/code
      </Text>

      <View style={{ flex: 1, justifyContent: "flex-end", paddingBottom: 48, width: "100%" }}>
        <TouchableOpacity
          onPress={onSkip}
          style={{ backgroundColor: colors.white, alignSelf: "center", borderRadius: 9999, paddingHorizontal: 32, paddingVertical: 8 }}
        >
          <Text style={{ color: colors.black, fontFamily: fontFamily.abhayaBold, fontSize: 18 }}>Skip</Text>
        </TouchableOpacity>
      </View>

      {showSpinner && (
        <View style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: colors.white, opacity: 0.7, alignItems: "center", justifyContent: "center" }}>
          <ActivityIndicator size="large" color="#0000ff" />
        </View>
      )}
    </View>
  );
}

export default ReferralScreen;
